import React from "react";

function phoneExcelCell(options, column, gridCell) {
  if (gridCell.value) {
    options.value = gridCell.value.replace(/\+|\(|\)|\W+|-/g, "");
  }
}

function phoneCell(config) {
  config.alignment = "center";
}

export {phoneCell, phoneExcelCell}
